export default {
  computed: {
    boxStyle () {
      const reg = /\D+/g
      const styleObj = {}
      // 判断传入的height、width是否是纯数字，若是纯数字，则在单位后加‘px’，否则，设置传入值
      if (this.height) {
        const height = reg.test(this.height + '') ? this.height : this.height + 'px'
        styleObj.height = height
      }
      if (this.width) {
        const width = reg.test(this.width + '') ? this.width : this.width + 'px'
        styleObj.width = width
      }
      return styleObj
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/styleMixin.js